<template>
    <div>
        <nav data-lenis-prevent="true" class="menu fixed right-6 top-0 w-full min-h-screen overflow-y-auto z-[99999] before:content-none md:before:content-[''] before:absolute before:w-[1px] before:h-[calc(100vh-94px)] before:left-[45%] before:top-0 before:bg-white before:bg-opacity-10 opacity-0">
            <div class="menu-close cursor-pointer sticky top-8 left-[89%] sm:left-[90%] md:left-[93%] lg:left-[94.7%] xl:left-[96.5%] 2xl:left-[96%] h-[40px] w-[40px] text-white">
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="30" height="30" viewBox="0 0 50 50">
                <path d="M 7.71875 6.28125 L 6.28125 7.71875 L 23.5625 25 L 6.28125 42.28125 L 7.71875 43.71875 L 25 26.4375 L 42.28125 43.71875 L 43.71875 42.28125 L 26.4375 25 L 43.71875 7.71875 L 42.28125 6.28125 L 25 23.5625 Z" fill="#fff"></path>
                </svg>
            </div>
            <div class="menu-wrapper relative max-w-[300px] sm:max-w-[400px] md:max-w-[600px] lg:max-w-[900px] xl:max-w-[1130px] mx-auto pb-4 flex flex-col gap-8 md:gap-16 md:top-20 z-[99999]">
                <ul class="menu-list">
                <li class="menu-list-item menu-list-item-anchor w-full ">
                    <router-link to="/services" class="text-white text-[28px] md:text-[42px] xl:text-[56px] leading-[70px] xl:leading-[90px] menu-list-item-text">Services</router-link>
                </li>
                <li class="menu-list-item menu-list-item-anchor w-full ">
                    <a @click.prevent  href="#" class="text-white text-[28px] md:text-[42px] xl:text-[56px] leading-[70px] xl:leading-[90px] menu-list-item-text">Projects</a>
                    <ul class="menu-list-item-dropdown relative md:absolute top-0 w-full md:w-auto h-fit left-0 md:left-[48%]">
                    <li>
                        <router-link to="/pairboard" class="text-white inline-block pb-1 pl-3 menu-list-item-dropdown-list text-base md:text-lg leading-8 md:leading-[50px] ">PairBoard - Custom Website/AI</router-link>
                    </li>
                    <li>
                        <router-link to="/off-melrose" class="text-white inline-block pb-1 pl-3 menu-list-item-dropdown-list text-base md:text-lg leading-8 md:leading-[50px] ">Off Melrose - Shopify</router-link>
                    </li>
                    <li>
                        <router-link to="/eoncycle" class="text-white inline-block pb-1 pl-3 menu-list-item-dropdown-list text-base md:text-lg leading-8 md:leading-[50px] ">Eoncycle - Shopify</router-link>
                    </li>
                    <li>
                        <router-link to="/finify" class="text-white inline-block pb-1 pl-3 menu-list-item-dropdown-list text-base md:text-lg leading-8 md:leading-[50px] ">Finify - Mobile App</router-link>
                    </li>
                    <li>
                        <router-link to="/blingram" class="text-white inline-block pb-1 pl-3 menu-list-item-dropdown-list text-base md:text-lg leading-8 md:leading-[50px] ">Blinggram - Mobile App</router-link>
                    </li>
                    </ul>
                </li>
                <li class="menu-list-item menu-list-item-anchor w-full ">
                    <router-link to="/contact" class="text-white text-[28px] md:text-[42px] xl:text-[56px] leading-[70px] xl:leading-[90px] menu-list-item-text">Contact</router-link>
                </li>
                </ul>
            </div>
            <div class="menu-footer max-lg:hidden lg:block fixed bottom-0 w-full border-t border-white border-opacity-10">
                <div class="menu-footer-content max-w-[300px] sm:max-w-[400px] md:max-w-[600px] lg:max-w-[900px] xl:max-w-[1130px] flex justify-between mx-auto py-8 flex-col md:flex-row">
                <p class="text-sm w-full md:w-auto mb-4 md:mb-0">
                    Los Angeles, CA
                </p>
                </div>
            </div>
            </nav>
        <div class="menu-overflow fixed z-[9999] bg-[rgba(10,10,10,0.95)] bg-opacity-60 backdrop-blur-[25px] w-full h-full pointer-events-none"></div>
    </div>
</template>

<script>
import { MenuHandler } from '@/legacy/initLegacy';

export default {
  name: 'NavComponent',
  mounted() {
    console.log('NavComponent mounted, initializing MenuHandler');
    MenuHandler.init(this.$el);
  },
  beforeUnmount() {
    console.log('NavComponent beforeUnmount, destroying MenuHandler');
    MenuHandler.destroy && MenuHandler.destroy();
  },
  watch: {
    $route() {
      this.$nextTick(() => {
        console.log('Route changed, calling MenuHandler.close()');
        MenuHandler.close();
      });
    }
  }
};
</script>